export const ru = {
  sights: 'Достопримечательности',
};
